import script from "./CreateTask.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateTask.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__